import './bootstrap';

// Metronic
import './metronic';

// Init code
Bolt.once('unload', (event) => {
    document.head.querySelectorAll('style').forEach((style) => {
        if (!style.hasAttribute('bolt-pin') && style.innerHTML.includes('url(/cf-fonts/')) {
            style.removeAttribute('bolt-transient');
            style.setAttribute('bolt-pin', '');
        }
    });
});

Bolt.on('unload', (event) => {
    delete document.body.dataset.offcanvasAside;

    KTUtil.data(document.querySelector('#kt_aside_menu')).get('ps')?.destroy();

    $('.modal').modal('hide');
    $('.tooltip').tooltip('dispose');
    $('.popover').popover('dispose');
});

Bolt.on('before-render', (event) => {
    const { oldDocument, newDocument } = event.detail;
    const checkedClass = 'aside-minimize-hover';

    if (oldDocument.body.classList.contains(checkedClass)) {
        newDocument.body.classList.add(checkedClass);
    }
});

Bolt.setTargetSelectors('#app-container');
Bolt.start();
